import { GridCol, mixins, styled } from '@bob/library'

export const Wrapper = styled(GridCol)`
  margin: 0 auto;
  ${mixins.padding(0, 20)}
`

export const Title = styled.h1`
  ${mixins.typography.headlineLarge};
  text-align: center;
`

export const Description = styled.p`
  ${mixins.typography.paragraphMedium}
  max-width: 630px;
  text-align: center;
  margin: 0 auto;
  ${mixins.margin.bottom(20)}
`

export const SelectWithLabel = styled.div`
  width: 100%;
  ${mixins.margin(5)}
`

export const SelectLabel = styled.p`
  ${mixins.typography.paragraphSmall}
`

export const SelectorWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 50px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  ${mixins.media.max.tablet} {
    flex-wrap: wrap;
  }
  ${mixins.media.min.desktop} {
    width: 50%;
  }
`

export const Items = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
`
export const LearnMoreButtonWrapper = styled.div`
  width: 100%;
  text-align: center;
  ${mixins.margin.top(30)}
`
